import { FC, ReactNode } from 'react';
import { Tab, TabList, Box, BoxProps } from '@chakra-ui/react';
import { FlexRow } from 'components/layout/FlexRow';

const tabStyles = {
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px 24px',
  gap: '8px',
  maxHeight: '32px',
  _selected: {
    backgroundColor: 'brand.white',
    border: '1px solid #EAECEA',
    boxShadow: '0px 4px 4px rgba(118, 116, 111, 0.15) !important',
    borderRadius: '4px',
  },
  backgroundColor: 'brand.dark-green-200',
  height: '90%',
};

const textStyles = {
  fontWeight: 600,
  fontSize: '13px',
  alignItems: 'center',
  letterSpacing: '-0.01em',
  color: 'brand.army-dark',
  gap: 'padding_4',
};

const tabsListStyle = {
  border: '1px solid #EAECEA',
  borderRadius: '4px',
};

const tabContainer = {
  backgroundColor: 'brand.dark-green-200',
  borderRadius: '4px',
};

export type TabLabel = string | { label: string | ReactNode; icon?: ReactNode };

interface TabsElementProps extends BoxProps {
  tabLabels: TabLabel[];
  onTabClick?: (() => void)[];
}

export const TabsList: FC<TabsElementProps> = ({ tabLabels, onTabClick }) => (
  <Box sx={tabContainer}>
    <TabList sx={tabsListStyle}>
      {tabLabels.map((tabLabel, index) => {
        const label = typeof tabLabel === 'string' ? tabLabel : tabLabel.label;
        const icon = typeof tabLabel === 'string' ? null : tabLabel.icon;

        return (
          // Tab order is fixed; labels may be React nodes without stable string ids.
          // eslint-disable-next-line react/no-array-index-key -- static tab list
          <Tab sx={tabStyles} key={`tab-options-${index}`}>
            <FlexRow onClick={() => onTabClick?.[index]?.()} sx={textStyles}>
              {label}
              {icon}
            </FlexRow>
          </Tab>
        );
      })}
    </TabList>
  </Box>
);
